/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Tue, Aug 3rd 2021, 2:34:19 pm
 *
 * *****************************************************
 */

import { ReactComponent as BackIcon } from 'assets/images/arrowLeftWithBody.svg';

import { Button } from './styles';

type Props = {
  onClick: () => void;
};

const BackButton = ({ onClick }: Props): JSX.Element => {
  return (
    <Button aria-label="back button" type="button" className="Polaris-Button" onClick={onClick}>
      <BackIcon />
    </Button>
  );
};

export default BackButton;
